import { deleteCaseApi } from 'Constants';
import { Context } from 'Context/Context';
import { Trash2 } from 'lucide-react'
import AreYouSureModal from 'Modals/AreYouSureModal';
import React, { useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

function CaseDetailsHeader({caseDetails}) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const {makeApiCallFunc} = useContext(Context);

   const deleteCase = () => {
         makeApiCallFunc(
          deleteCaseApi,
          { id: caseDetails?._id },
          ({data})=>
          {
              setShowModal(false);
              navigate("/client/cases");
              console.log(data)
          },
          function (error) {
              console.log(error)
          }
         )
      }

  return (
    <>
     {
            showModal &&
            <AreYouSureModal
            uploadNew= {showModal}
            text = "Are you sure you want to delete this case?"
            buttonName = "Yes, Delete Case"
             onClose={()=> setShowModal(false)}
             onSubmit = {deleteCase}
            />
        }
    <div className="grid grid-cols-4 lg:grid-cols-3 items-center z-50 h-[50px] lg:h-[70px] px-4 bg-ivory border-b border-[rgba(20,33,61,.1)] sticky top-0 shadow-sm text-navy font-plexsans">
        <div className='flex w-full col-span-1'>
        <Link to="/client/cases">
                <div className='text-[13px]'>
                    <span className='flex font-semibold items-center text-tan hover:text-tanDark'>
                    &larr;
                    <span className='hidden lg:block ml-2'>Back to my cases
                      </span>
                    </span>
                    </div>
            </Link>
            </div>
            <div className='w-full col-span-2 lg:col-span-1 lg:text-[14px] text-[13px] flex justify-center text-center font-semibold text-navy'>
              {caseDetails?.caseNumber}
            </div>
            <div className='w-full flex justify-end col-span-1'>
              <Trash2 className='cursor-pointer text-[rgba(20,33,61,.4)] hover:text-[rgba(20,33,61,.7)] w-[15px] h-[15px]'
               onClick={() => setShowModal(true)}
              />

            </div>
    </div>
    </>
  )
}

export default CaseDetailsHeader
